<template>
	<router-view></router-view>
</template>

<script>
export default {
	name: "ProjectEdit"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
